<main class="flex-1">
    <div class="p-3 bg-gray-50">
        <div class="bg-white border border-gray-200 rounded-lg shadow-sm">

            <div class="p-3">
                <div class="flex items-center justify-between mb-2">
                    <h3 class="text-xl font-semibold leading-none tracking-tight text-gray-900">
                        Órdenes de Compra Pendientes
                    </h3>

                    <div class="flex items-center gap-2 text-gray-700">
                        <span class="text-base font-medium">Conceptos</span>
                        <mat-icon>inventory_2</mat-icon>
                    </div>
                </div>

                <div class="flex justify-between gap-4 items-end">

                    <div class="flex">
                        <div class="flex items-center space-x-2 mr-3 border-b border-gray-400">
                            <label for="from-date" class="text-gray-700 text-sm font-medium relative top-[4px]">
                                Fecha desde
                            </label>
                            <input type="date" id="from-date" [(ngModel)]="fromDate" [max]="toDateMax"
                                class="form-input block border-gray-300 text-sm rounded-xs" />
                        </div>

                        <div class="flex items-center space-x-2 border-b border-gray-400">
                            <label for="to-date" class="text-gray-700 text-sm font-medium relative top-[4px]">
                                Fecha hasta
                            </label>
                            <input type="date" id="to-date" [(ngModel)]="toDate" [max]="toDateMax"
                                class="form-input block border-gray-300 text-sm rounded-xs" />
                        </div>

                        <div class="flex items-center space-x-2 border-b border-gray-400 ml-6">
                            <label for="moneda" class="text-gray-700 text-sm font-medium relative top-[4px]">
                                Moneda
                            </label>
                            <select [(ngModel)]="this.monedaSeleccionada" id="moneda" name="currency"
                                class="h-8 w-full border-gray-300 rounded-md px-2 text-sm outline-none"
                                (ngModelChange)="onCurrencyChange($event)">
                                @for (moneda of monedas; track moneda.mone) {
                                <option [value]="moneda.mone">{{ moneda.mone}}</option>
                                }
                            </select>
                        </div>
                        
                    </div>

                    <div>
                        <button (click)="consultar()"
                            class="bg-blue-600 text-white h-7 px-3 rounded-md text-sm font-medium hover:bg-blue-700">
                            Buscar
                        </button>
                    </div>

                </div>



            </div>

            <div class="p-6 pt-0">
                <div class="relative w-full">
                    <div class="overflow-y-auto h-[calc(100vh-16.5rem)]">
                        <table class="w-full text-xs table-fixed">
                            <thead class="bg-[#ededed] border-b border-gray-400  sticky top-0 z-10">
                                <tr>
                                    <th class="h-10 px-2 text-left text-gray-500 w-[30px]">
                                        <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll()"
                                            class="h-4 w-4 shrink-0 rounded border border-gray-400 focus:ring-blue-500">
                                    </th>
                                    <th class="h-10 px-1 text-left font-medium text-gray-500 w-[150px]">Descripción</th>
                                    <th class="h-10 px-2 text-right font-medium text-gray-500 w-[90px]">#</th>
                                    <th class="h-10 px-2 text-left font-medium text-gray-500 w-[100px]">Fecha</th>
                                    <th class="h-10 px-2 text-right font-medium text-gray-500 w-[40px]">Item</th>
                                    <th class="h-10 px-2 text-left font-medium text-gray-500 w-[80px]">C&oacute;digo
                                    </th>
                                    <th class="h-10 px-1 text-left font-medium text-gray-500 w-[240px]">Concepto</th>
                                    <th class="h-10 px-1 text-right font-medium text-gray-500 w-[100px]">Imp.Pendiente
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (registro of registros; track getOrderKey(registro)) {
                                <tr class="border-b hover:bg-gray-50/50">
                                    <td class="px-2 py-2 align-middle w-[30px]">
                                        <input type="checkbox" [checked]="selectedOrderIds.has(getOrderKey(registro))"
                                            (change)="toggleOrderSelection(registro)"
                                            class="h-4 w-4 shrink-0 rounded border border-gray-400 focus:ring-blue-500">
                                    </td>



                                    <td class="px-1 py-2 align-middle text-gray-600">
                                        {{ registro.descrip }}
                                    </td>

                                    <td class="px-2 py-2 text-right align-middle text-gray-600">
                                        {{ registro.NUM }}
                                    </td>

                                    <td class="px-2 py-2 text-left align-middle text-gray-600">
                                        {{ registro.FECHA | date:'dd/MM/yyyy':'UTC' }}
                                    </td>

                                    <td class="px-2 py-2 text-right align-middle text-gray-600">
                                        {{ registro.renglon }}
                                    </td>

                                    <td class="px-2 py-2 align-middle text-gray-600" [title]="registro.codi_concep">
                                        {{ registro.codi_concep }}
                                    </td>

                                    <td class="px-1 py-2 align-middle text-gray-600">
                                        {{registro.descrip_concep }}
                                    </td>

                                    <td class="px-1 py-2 align-middle text-right font-medium">
                                        {{registro.MONE=='PES'? '$':registro.MONE}}
                                        {{ registro.impor_pend | number:'1.2-2' }}
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-between p-6 pt-0">
                <div class="text-base font-medium text-gray-800">
                    <ng-container *ngIf="registros && registros.length>0">
                        Total seleccionado:
                        <span class="font-bold">
                            {{monedaSeleccionada=='PES'? '$':monedaSeleccionada}} {{ totalSelected | number:'1.2-2' }}
                        </span>
                    </ng-container>
                </div>
                <app-mini-loader *ngIf="miniLoader"></app-mini-loader>
                <button (click)="generateInvoice()" [disabled]="selectedOrderIds.size === 0 || this.miniLoader"
                    class="bg-blue-600 text-white h-10 px-5 py-2 rounded-md text-sm font-medium hover:bg-blue-700 w-full sm:w-auto disabled:opacity-50 disabled:cursor-not-allowed">
                    Generar Factura
                </button>
            </div>
        </div>
    </div>

</main>